import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import PMVidyalaxmiSchemeEle from './PMVidyalaxmiSchemeEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Scholarship" />
            <PMVidyalaxmiSchemeEle />
        </>
    )
}

export default Main